import clsx from "clsx";
import { useTransactionFeesSummaryTableRetrieveSuspense } from "gen/endpoints/capital-activity/capital-activity";
import React from "react";
import { TableBox } from "shared/components/table/box/TableBox";
import { TableBoxBody } from "shared/components/table/box/TableBoxBody";
import { TableBoxCollapse } from "shared/components/table/box/TableBoxCollapse";
import { TableBoxHeader } from "shared/components/table/box/TableBoxHeader";
import { TableBoxTitle } from "shared/components/table/box/TableBoxTitle";
import { DataTable } from "shared/components/table/data/DataTable";
import { DataTableBoxActions } from "shared/components/table/data/DataTableBoxActions";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";

interface FeeSummaryTableProps {
  feeChargeEventIds: string[];
  isCollapsed?: boolean;
  title: string;
  fundId?: string;
  groupByFund?: boolean;
}

export const FeeSummaryTable: React.FC<FeeSummaryTableProps> = ({
  fundId,
  feeChargeEventIds,
  title,
  isCollapsed = false,
  groupByFund = false,
}) => {
  const { fundFamilyId, fundFamilyEventId } = useRequiredStringParams();
  const { data: feeSummaryTable } =
    useTransactionFeesSummaryTableRetrieveSuspense(
      fundFamilyId,
      fundFamilyEventId,
      {
        fee_charge_event_ids: feeChargeEventIds,
        fund_id: fundId,
        group_by_fund: groupByFund,
      },
    );

  return (
    <TableBox
      isDefaultExpanded={!isCollapsed}
      isFullWidth={true}
      boxProps={
        isCollapsed
          ? {
              sx: {
                "&.mb-tablebox-collapsed": {
                  boxShadow: "none",
                  borderBottomWidth: "1px",
                },
              },
            }
          : undefined
      }
    >
      <TableBoxHeader>
        <TableBoxTitle>{title}</TableBoxTitle>
        <DataTableBoxActions />
      </TableBoxHeader>
      {isCollapsed ? (
        <TableBoxCollapse>
          <TableBoxBody borderBottom="1px solid" borderColor="gray.200">
            <DataTable
              data={feeSummaryTable}
              headerOrCellClass={(params) =>
                clsx({
                  "mb-cell-highlighted":
                    params.column?.getColId() == "total_outstanding_fees",
                })
              }
            />
          </TableBoxBody>
        </TableBoxCollapse>
      ) : (
        <TableBoxBody>
          <DataTable
            data={feeSummaryTable}
            headerOrCellClass={(params) =>
              clsx({
                "mb-cell-highlighted":
                  params.column?.getColId() == "total_outstanding_fees",
              })
            }
          />
        </TableBoxBody>
      )}
    </TableBox>
  );
};
